let CURRENT_PAGE = 1
let LOADING = false

export default class RelatedService {
  constructor() {
    this.init();
  }

  init() {
    let that = this;
    $('.related-services').each((index, element) => {
      $(element).find('.load-more').on('click', function () {
        if (LOADING) return;
        that.loadMore(element)
      });
    });

    document.addEventListener('aos:in:inview', function(e) {
      setTimeout(() => {
        e.detail.classList.remove('overflow-hidden');
        e.detail.querySelector('.wrapper').classList.remove('bottom-0');
      }, 2000);
    });
  }

  loadMore(element) {
    let that = this, id;
    const spinner = $(element).find('.load-more').closest('div').find('svg')
    if ($(element).data('homepage')) {
      id = 0;
    } else {
      id = $(element).data('id');
    }
    if (LOADING) return;

    $.ajax({
      type: 'GET',
      url: '/wp-json/api/v1/related_services',
      data: {
        post_id: id,
        offset: 6,
      },
      beforeSend: function () {
        LOADING = true;
        spinner.show()
      },
      success: function (data) {
        CURRENT_PAGE = parseInt(data.current_page);
        if (data.data.length > 0) {
          that.appendData(element, data.data)
        }

        if (data.next_page === null) {
          $(element).find('.load-more').hide()
        }
      },
      complete: function () {
        LOADING = false
        spinner.hide()
      },
    })
  }

  appendData (element, data) {
    $.each(data, function (index, item) {
      $(element).find('.list').append(`
      <div class="col-span-1">
        <a href="${item.link}" class="
          item relative flex
          h-40 lg:h-48
          cursor-pointer
        ">
          <div class="
            wrapper
            absolute left-0 top-0
            w-full h-40 lg:h-48
            px-10 xxl:px-14
            bg-no-repeat bg-cover bg-gray-400 bg-center
            transition-[height]
          " style="background-image: linear-gradient(rgba(17,45,79,.5),transparent)${(item.thumbnail ? `,url('${item.thumbnail}');` : ';')}">
            <div class="flex justify-between items-center w-full h-full lg:w-3/4 2xl:w-1/2 z-[1]">
              <span class="
                title text-white font-bold uppercase
                text-xl
                mr-5
              ">
                ${item.title}
              </span>

              <span class="
                arrow text-white
                flex justify-center items-center flex-shrink-0
                w-10 lg:w-12 xl:w-14 2xl:w-16
                h-10 lg:h-12 xl:h-14 2xl:h-16
                border border-white rounded-full
                transition
              ">
                <svg xmlns="http://www.w3.org/2000/svg" width="9.907" height="12.824" viewBox="0 0 9.907 12.824" class="transform" class="w-2 xl:w-auto">
                  <path d="M391.258,300.5l8.74,6-8.74,6" transform="translate(-390.975 -300.088)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1" />
                </svg>
              </span>
            </div>
          </div>
        </a>
      </div>
    `)
    })
  }
}
